
    
export const constants = {
    'backend_url': 'https://pleinair.bitage.it',
    'frontend_url': 'https://pleinairapp.fencity.com',
    //'environment': 'iOS'
    'environment': window.webkit && window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getData ? 'iOS'
    : typeof Print !== 'undefined' && Print.postMessage ? 'Android' : 'Web',
    'maps_api_key': "AIzaSyB3GkX1lXE43JcJisD42AJ11o3WMCC53-Y"
};
 
export default constants;
